import React from 'react';
import { SpacingToken } from '../../theme/tokens/spacing';
import { ResponsiveTokenSet } from '../../theme/tokens/types';

import { ITextOnlyHeroFields } from '../../../types/contentful';

import { BlockContainer, Layout, Column } from '../Layout';
import { Text } from '../Text';

import { HeroCopyColumn } from './styles';

interface Props extends ITextOnlyHeroFields {
  yMarginTopOverride?: ResponsiveTokenSet<SpacingToken>;
  yMarginBottomOverride?: ResponsiveTokenSet<SpacingToken>;
}

export function TextOnlyHero({
  headingText,
  heroCopy,
  yMarginTopOverride,
  yMarginBottomOverride
}: Props) {
  return (
    <BlockContainer
      as="section"
      data-blockid="text-only-hero"
      data-testid="text-only-hero"
      marginTop={yMarginTopOverride ?? { 0: '3xl', tablet: '5xl' }}
      marginBottom={yMarginBottomOverride ?? 'xl'}
      revealOnScroll={false}
      data-e2e="hero"
    >
      <Layout gutter={{ 0: 'ml', desktop: 'l' }}>
        <Column size={12} justifyContent="center" flexDirection="column">
          <Text
            as="h1"
            fontWeight="h1"
            fontSize={{ 0: 'h1_0', tablet: 'h1_tablet' }}
            colour="defaultText"
            textAlign="center"
          >
            {headingText}
          </Text>
        </Column>
        {heroCopy && (
          <HeroCopyColumn size={12} justifyContent="center">
            <Text
              as="h3"
              fontWeight="p"
              fontSize={{ 0: 'h3_0', tablet: 'h3_tablet' }}
              colour="defaultText"
              textAlign="center"
            >
              {heroCopy}
            </Text>
          </HeroCopyColumn>
        )}
      </Layout>
    </BlockContainer>
  );
}
